/** @module Camunda/TaskViewStoreIdRenderer */
define([
	"dojo/_base/declare",
	"csi/def",
	"csi/heading/String",
	"csi/locale",
	"csi/xml"
], function(declare,def,StringRen,locale,xml) {

	return declare(StringRen, {
		/**
		 * @override
		 * Return name for view
		 */
		toValue: function(ctx, h) {
			var value = this.inherited(arguments);
			if (value) {
				const portal = xml.enumGetText(ctx.getNode().ViewPortal);
				const portalType = (portal === "Supplier") ? portal : null;
				const keyObj = def.decomposeViewKey(value);
				const type = keyObj.type;
				const id = keyObj.id;
				
				value = (id === def.getHostViewId(portalType)) ? locale.resource("ViewConfigurationRoot") : locale.typeView(type, id);
			}
			
			return value;
		}
	});
});